import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const keyOf = (i) => `${i.source}:${i.ext_id || i.product_id}:${JSON.stringify(i.selected_options || {})}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vice_cart_v2") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("vice_cart_v2", JSON.stringify(items));
  }, [items]);

  const add = (item) =>
    setItems((prev) => {
      const k = keyOf(item);
      const found = prev.find((i) => keyOf(i) === k);
      if (found) return prev.map((i) => (keyOf(i) === k ? { ...i, quantity: i.quantity + 1 } : i));
      return [...prev, { ...item, quantity: 1, _key: k }];
    });

  const setQty = (k, quantity) =>
    setItems((prev) =>
      quantity <= 0 ? prev.filter((i) => keyOf(i) !== k) : prev.map((i) => (keyOf(i) === k ? { ...i, quantity } : i))
    );

  const remove = (k) => setItems((prev) => prev.filter((i) => keyOf(i) !== k));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, total, keyOf }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
